<template>
    <div aria-labelledby="modal-title" aria-modal="true" class="fixed z-10 inset-0 overflow-y-auto" role="dialog">
        <div class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <div aria-hidden="true"
                 class="fixed inset-0 bg-gray-300 dark:bg-gray-600 opacity-75 transition-opacity"></div>
            <span aria-hidden="true" class="hidden sm:inline-block sm:align-middle sm:h-screen">&#8203;</span>
            <div
                class="inline-block align-bottom bg-white dark:bg-gray-900 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle z-100">
                <div class=" px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                    <div class="sm:flex sm:items-start" style="max-height: 350px; overflow-y: auto">
                        <div class="mt-3 text-left">
                            <h3 id="modal-title" class="text-lg leading-6 font-medium text-gray-900 dark:text-gray-300">
                                Enviar Imagem
                            </h3>
                            <div class="mt-2">
                                <img :src="imageUrl" alt="" style="max-height: 300px"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="bg-gray-50 dark:bg-gray-800 px-4 py-3 sm:px-6 buttons-area">
                    <button
                        :disabled="sending"
                        class="disabled:opacity-25 inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 ml-3 w-auto text-sm"
                        type="button"
                        @click="sendImage">
                        Enviar Imagem
                    </button>
                    <button
                        class="inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 dark:text-white hover:bg-gray-50 dark:bg-gray-800 dark:hover:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 mt-0 ml-3 w-auto text-sm"
                        type="button"
                        @click="$emit('closeModal')">
                        Cancelar
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import {onMounted, ref} from "vue"
import {useMessageStore} from "@src/stores/messages";

const emit = defineEmits(['closeModal'])

const props = defineProps<{
    file: DataTransferItem | File
}>()

const imageUrl = ref('')
const resolvedFile = ref<File | null>(null)
const sending = ref(false)

const ALLOWED_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'webp']

onMounted(() => {
    // Aceita tanto DataTransferItem (paste/drag) quanto File direto
    const blob = props.file instanceof File
        ? props.file
        : props.file.getAsFile()

    if (!blob) return

    resolvedFile.value = blob

    const reader = new FileReader()
    reader.readAsDataURL(blob)
    reader.onload = (event) => {
        imageUrl.value = event.target?.result as string
    }
})

const sendImage = async () => {
    if (!resolvedFile.value || sending.value) return

    const messageStore = useMessageStore()

    sending.value = true
    emit('closeModal')

    await messageStore.submitMedia(
        [resolvedFile.value],
        'image',
        ALLOWED_EXTENSIONS
    )

    sending.value = false
}
</script>
<style scoped>
.buttons-area {
    display: flex;
    flex-direction: row-reverse;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-content: stretch;
    align-items: center;
}

.buttons-area button {
    cursor: pointer;
    padding: 8px 16px;
}
</style>